import { Component, Input, OnInit } from '@angular/core';
import { DocumentoPac } from 'src/app/model/DocumentoPac';

@Component({
  selector: 'app-informacoes-da-compradora',
  templateUrl: './informacoes-da-compradora.component.html',
  styleUrls: ['./informacoes-da-compradora.component.scss'],
  standalone: false
})
export class InformacoesDaCompradoraComponent implements OnInit {

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  constructor() { }

  ngOnInit(): void {
    
  }
}
